module.exports = __webpack_public_path__ + "img/sd-logo-white.6885d579.svg";